export default "__VITE_ASSET__CfPIe6$g__"